import { CAT_AI_NEWS_PROMPTS } from 'App/utils/Collections';
import { FT_LIST, FT_AUTOCOMPLETE } from '../FilterTypes';
import { loadCategories } from './loaders';
import { searchStaff } from '@/components/filters/config/loaders/users';

const groups = {
  general: {
    name: 'General',
    groupOrderIndex: 0,
  },
};

export default {
  category: CAT_AI_NEWS_PROMPTS,
  filters: [
    {
      id: 'category_id',
      label: 'Categories',
      group: groups.general,
      type: FT_LIST,
      placeholder: 'Choose categories',
      multiValues: false,
      getListItems: loadCategories,
    },
    {
      id: 'user_identifier',
      label: 'Creator',
      group: groups.general,
      type: FT_AUTOCOMPLETE,
      fieldConf: {
        multiple: false,
        searcher: async (term) => {
          const results = await searchStaff(term, { properties: ['id', 'name', 'email'] });
          return results.map(({ text, email }) => ({ text, value: email }));
        },
      },
    },
  ],
  searchBarProp: 'complex_name',
};
